import React from 'react';
import { connect } from 'dva';
import IncomeDetailModal from 'components/IncomeDetailModal/Index.js';

@connect(({ schoolOrder, loading }) => ({
  modal: schoolOrder.modal,
  loading: loading.effects['schoolOrder/fetchOrderDetail'],
  orderDetail: schoolOrder.orderDetail,
}))
export default class DetailModal extends React.Component {
  render() {
    const { modal: { show }, loading, orderDetail, dispatch } = this.props;

    return (
      <IncomeDetailModal
        showStudentInfo
        detail={orderDetail}
        loading={loading}
        visible={show}
        onCancel={() => {
          dispatch({
            type: 'schoolOrder/toggleModalVisibility',
            modal: {
              show: false,
            },
          });
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/School/Order/Modal/DetailModal.js